export enum DocumentOrigin {
    //CRM = '1',
    Portal = '2',
    Both = '3'
}
